<template>
  <!-- 资讯管理 -->
  <div class="advisoryMan">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['资讯管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd(false)"
          >添加消息</el-button
        >
        <el-button type="danger" @click="handleDel()">删除</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">发布状态：</label>
        <el-select
          placeholder="发布状态"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.status"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="已发布" value="2"></el-option>
          <el-option label="未发布" value="1"></el-option>
        </el-select>
        <el-date-picker
          type="date"
          v-model="searchForm.start"
          style="width: 200px; margin-right: 5px"
          placeholder="选择开始日期"
          value-format="yyyy-MM-dd" 
          clearable
        >
        </el-date-picker>
        <el-date-picker
          type="date"
          v-model="searchForm.end"
          style="width: 200px; margin-right: 5px"
          placeholder="选择结束日期"
          value-format="yyyy-MM-dd" 
          clearable
        >
        </el-date-picker>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入消息名称"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      @selection-change="selectionChange"
      style="width: 100%"
      row-key="id"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="排序" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ scope.row.sortId }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="id"
        show-overflow-tooltip
        label="ID"
      >
      </el-table-column>
      <el-table-column
        prop="classify"
        align="center"
        show-overflow-tooltip
        label="分类"
      >
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>

      <el-table-column
        prop="updateTime"
        label="添加时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>

      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 2">已上架</el-tag>
          <el-tag type="warning" v-else-if="scope.row.status == 1"
            >已下架</el-tag
          >
          <el-tag type="info" v-else-if="scope.row.status == 0">已删除</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="160">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 2">
            <el-button
              type="warning"
              style="padding: 2px 3px"
              plain
              @click="changeStatus(scope.row, '1')"
              >下架</el-button
            >
          </div>
          <div v-else-if="scope.row.status == 1">
            <el-button
              type="primary"
              style="padding: 2px 3px"
              plain
              @click="handleAdd(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="success"
              style="padding: 2px 3px"
              plain
              @click="changeStatus(scope.row, '2')"
              >上架</el-button
            >
            <!-- <el-button
              type="danger"
              style="padding: 2px 3px"
              plain
              @click="changeStatus(scope.row, '0')"
              >删除</el-button
            > -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "advisoryMan",
  data() {
    return {
      /**表格数据 */
      // {
      //   id:"ID",
      //   classify:"分类",
      //   title:"标题",
      //   main:"摘要",
      //   updateTime:"更新时间",
      //   browse:"浏览次数",
      //   status:"发布状态"
      // }
      tableData: [],
      selectedList: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        type: "",
        status: "",
        start: "",
        end: "",
        name: "",
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    /**获取数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        entid: localStorage.getItem("entId"),
        category: this.searchForm.type,
        channelId: "20",
        status: this.searchForm.status,
        name: this.searchForm.name,
        startDate: this.searchForm.start ? this.searchForm.start.split('T')[0] : '',
        endDate: this.searchForm.end ? this.searchForm.end.split('T')[0] : '',
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      this.$request({
        method: "post",
        url: "Article/GetPopularScience",
        data: data,
      })
        .then((res) => {
          this.tableData = [];
          if (res.success) {
            this.tableData = res.list.map((item) => ({
              id: item.Id,
              classify: item.Category,
              title: item.Title,
              main: item.zhaiyao,
              updateTime: item.Add_Time,
              status: item.Status,
              sortId: item.Sort_Id,
            }));
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**新增/编辑咨询 */
    handleAdd(row) {
      let prams = null;
      if (row) {
        const sortId = row.sortId || 0;
        prams = encodeURIComponent(JSON.stringify({ 
          id: row.id,
          sortId: sortId
        }));
      }
      this.$router.push({
        path: "advisoryManLits",
        query: {
          prams: prams,
        },
      });
      prams = null;
    },
    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    handleDel() {
      let row = {};
      if (this.selectedList.length == 1) {
        row = this.selectedList[0];
        if (row.status !== 0) {
          this.changeStatus(row, 0);
        }
      } else {
        this.$message({
          message: "只能删除一条数据",
          type: "warning",
        });
      }
    },
    // 更改状态
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let type = "info";
      if (status == 1) {
        msg = "确定下架吗?";
        type = "warning";
      } else if (status == 2) {
        msg = "确定上架吗?";
        type = "success";
      } else if (status == 0) {
        msg = "确定删除吗?";
        type = "error";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            type: "upArticlestatus",
            id: row.id,
            status: status,
          };
          let proc = ""; // 存储过程名
          let type = "UpdateArticle";
          this.$requestSys({
            url:
              "article/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.advisoryMan {
  width: 100%;
  height: 100%;
}
</style>
